var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnimals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 37,
    viewBox: "0 0 42 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.112 11.015C37.8106 10.8965 37.4894 10.836 37.1654 10.8369H37.1315C35.4207 10.8624 33.502 12.4646 32.4952 14.888C31.2881 17.7872 31.8437 20.7534 33.7454 21.516C34.0466 21.6345 34.3675 21.695 34.6912 21.6941C36.4105 21.6941 38.3555 20.0825 39.3708 17.643C40.5693 14.7438 40.0053 11.7776 38.112 11.015Z",
    stroke: "#15D4B6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0731 22.3288C24.715 18.416 23.6972 16.9443 20.9998 16.9443C18.3025 16.9443 17.2762 18.4253 14.9181 22.3288C12.8994 25.6674 8.81947 25.9456 7.80161 28.7812C7.59512 29.3006 7.49141 29.8551 7.49626 30.414C7.49626 32.7203 9.26054 34.5872 11.432 34.5872C14.1293 34.5872 17.8021 32.4336 21.0083 32.4336C24.2146 32.4336 27.8704 34.5872 30.5677 34.5872C32.7392 34.5872 34.495 32.7211 34.495 30.414C34.4969 29.8546 34.3903 29.3 34.1811 28.7812C33.1633 25.9354 29.0918 25.6674 27.0731 22.3288Z",
    stroke: "#15D4B6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6142 13.2121C15.7277 13.2122 15.8412 13.2037 15.9534 13.1866C17.9222 12.9008 19.1512 10.1729 18.7051 7.0922C18.2852 4.18791 16.5226 2.01563 14.6794 2.01563C14.5659 2.01553 14.4524 2.02404 14.3401 2.04107C12.3714 2.32692 11.1424 5.05478 11.5885 8.1355C12.0084 11.0313 13.771 13.2121 15.6142 13.2121Z",
    stroke: "#15D4B6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4086 8.1355C30.8547 5.05478 29.6257 2.32692 27.657 2.04107C27.5447 2.02404 27.4313 2.01553 27.3177 2.01563C25.4745 2.01563 23.7153 4.18791 23.2946 7.0922C22.8484 10.1729 24.0775 12.9008 26.0462 13.1866C26.1585 13.2037 26.2719 13.2122 26.3855 13.2121C28.2287 13.2121 29.9913 11.0313 30.4086 8.1355Z",
    stroke: "#15D4B6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25713 21.516C10.1563 20.7526 10.711 17.7838 9.5057 14.888C8.49124 12.4485 6.54798 10.8369 4.83119 10.8369C4.50751 10.836 4.1866 10.8965 3.88543 11.015C1.98627 11.7784 1.43154 14.7472 2.63685 17.643C3.65132 20.0825 5.59458 21.6941 7.31137 21.6941C7.63505 21.695 7.95596 21.6345 8.25713 21.516Z",
    stroke: "#15D4B6",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnimals);
export default __webpack_public_path__ + "static/media/iconAnimals.60a849a98f16bbb10fab9e640184e9c2.svg";
export { ForwardRef as ReactComponent };